
export class RoleResponse implements IRoleResponse {
  userRoleId?: number;
  userRoleName?: string | undefined;
  userRoleDescription?: string | undefined;

  constructor(data?: IRoleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userRoleId = _data["userRoleId"];
      this.userRoleName = _data["userRoleName"];
      this.userRoleDescription = _data["userRoleDescription"];
    }
  }

  static fromJS(data: any): RoleResponse {
    data = typeof data === "object" ? data : {};
    let result = new RoleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userRoleId"] = this.userRoleId;
    data["userRoleName"] = this.userRoleName;
    data["userRoleDescription"] = this.userRoleDescription;
    return data;
  }
}

export interface IRoleResponse {
  userRoleId?: number;
  userRoleName?: string | undefined;
  userRoleDescription?: string | undefined;
}
